export interface BoxStatusViewerVm {
    type: 'boxStatus';
    value: boolean;
}

export default function buildBoxStatusViewer(value: boolean): BoxStatusViewerVm {
    return { type: 'boxStatus', value };
}
